// LoadingAnimation.js
import React from 'react';
import Lottie from 'react-lottie';
import animationData from '../assets/mXckiEmPTQ.json';

const LoadingAnimation = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true, // Starts the animation automatically
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice', // Controls how the animation is rendered
    },
  };

  return (
    <div style={{ width: 200, height: 200 }}>
      <Lottie options={defaultOptions} height={200} width={200} />
    </div>
  );
};

export default LoadingAnimation;
